<div class="upload-file-container">
  <h2 class="dialog-title">UPLOAD FILE</h2>
  <button mat-icon-button class="close-button" (click)="closeModal()">
    <mat-icon>close</mat-icon>
  </button>

  <div *ngIf="!reuseExistingPdf && !uploadInProgress && !selectedFile" class="upload-area">
    <div
      class="upload-drag-drop"
      (drop)="onFileDropped($event)"
      (dragover)="onDragOver($event)"
    >
      <mat-icon class="upload-icon">upload</mat-icon>
      <p class="upload-text">Drag your file here to upload</p>
      <button mat-raised-button color="accent" class="choose-file-button" (click)="fileInput.click()">
        CHOOSE FILE
      </button>
      <input
        #fileInput
        type="file"
        accept=".pdf"
        hidden
        (change)="onFileSelected($event)"
        [disabled]="reuseExistingPdf"
      />
    </div>
  </div>

  <div *ngIf="uploadInProgress || checkingExistingFiles" class="upload-progress">
    <p *ngIf="uploadInProgress" class="file-name">{{ selectedFile?.name }}</p>
    <mat-progress-spinner *ngIf="uploadInProgress" mode="indeterminate" diameter="30" color="primary"></mat-progress-spinner>
    <div *ngIf="checkingExistingFiles" class="checking-files-message">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Checking if file already exists...</span>
    </div>
    <div *ngIf="validatingPdf" class="checking-files-message">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Validating PDF file...</span>
  </div>
  </div>
  <div *ngIf="validationMessage" class="validation-message">
    {{ validationMessage }}
  </div>
  <div *ngIf="fileSelected" class="upload-completed">
    <div class="file-details">
      <mat-icon class="chat-reply-answer-source-file-card-icon">picture_as_pdf</mat-icon>
      <p><strong>Filename:</strong> {{ selectedFile?.name }}</p>
      <p *ngIf="uploadCompleted"><strong>Uploaded:</strong> {{ uploadDate }}</p>
    </div>
    <div *ngIf="uploadCompleted" class="file-actions">
      <p class="completed-status">Completed</p>
      <button mat-button class="button view-button" (click)="openPDFModal()">
        <mat-icon>visibility</mat-icon>
        View PDF
      </button>
    </div>
    <div *ngIf="uploadError" class="file-actions">
      <p class="failed-status">Failed</p>
    </div>
  </div>
  <div class="category-dropdown" *ngIf="!uploadInProgress">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Select category for the file</mat-label>
      <mat-select [(ngModel)]="selectedCategory">
        <mat-option *ngFor="let category of categories" [value]="category">{{ category }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-checkbox
    *ngIf="!uploadCompleted"
    [(ngModel)]="reuseExistingPdf"
    name="existingPdfSelection"
    style="margin-top: 10px;"
  >
    Reuse existing PDF for this Make & Model
  </mat-checkbox>

  <div *ngIf="reuseExistingPdf" class="existing-pdf-list" style="margin-top: 20px;">
    <mat-selection-list [(ngModel)]="selectedExistingPdf" [multiple]="false">
      <mat-list-option *ngFor="let res of data.existingResources" [value]="res" class="pdf-option">
        <div class="pdf-option-content">
          <mat-icon class="pdf-file-card-icon">picture_as_pdf</mat-icon>
          <div class="pdf-info">
            <strong>{{ res.file_name }}</strong>
          </div>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </div>

  <div class="upload-actions" style="margin-top: 20px;">
    <button
      *ngIf="!uploadCompleted"
      mat-raised-button
      class="discard-button"
      (click)="closeModal()"
    >
      <mat-icon>close</mat-icon>
      DISCARD
    </button>
    <button
        mat-raised-button
        class="confirm-button"
        (click)="uploadFile()"
        [disabled]="uploadInProgress || validatingPdf"
      >
        <mat-icon>check</mat-icon>
        CONFIRM
      </button>
  </div>
</div>